import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'
import { Injectable } from '@angular/core'
import { environment } from '../../environments/environment'
import { GenericEvents } from '@newrelic/browser-agent/features/generic_events'

export enum BookingAction {
    CheckAvailability = 'check_availability',
    SelectRestrictions = 'select_restrictions',
    SelectBookingType = 'select_booking_type',
    SelectStandardBooking = 'select_standard_booking',
    SelectEvent = 'select_event',
    SelectReason = 'select_reason',
    SelectDuration = 'select_duration',
    SelectArea = 'select_area',
    SelectTime = 'select_time_slot',
    ConfirmBookingOptions = 'confirm_booking_options',
    ProceedToCardDetails = 'proceed_to_card_details',
    ProceedToDepositPayment = 'proceed_to_deposit_payment',
    Book = 'book',
    ViewBookingConfirmation = 'view_booking_confirmation',
    CancelBookingConfirmed = 'cancel_booking_confirmed',
    CancelBookingDismissed = 'cancel_booking_dismissed',
}

@Injectable({
    providedIn: 'root',
})
export class LoggingService {
    private browserAgent?: BrowserAgent
    // Storefront can render before AppComponent starts the agent after Angular stabilises.
    private pendingStorefrontActions: Parameters<LoggingService['trackAction']>[] = []

    setUp() {
        const applicationId = environment.newRelicApplicationId
        if (applicationId.length === 0) {
            return
        }
        const options = this.makeOptions()
        options.info.applicationID = applicationId
        options.loader_config.applicationID = applicationId
        options.loader_config.agentID = applicationId
        this.browserAgent = this.createBrowserAgent(options)
        this.pendingStorefrontActions.splice(0).forEach(args => this.trackAction(...args))
    }

    noticeError(error: Error) {
        if (this.browserAgent) {
            this.browserAgent.noticeError(error)
        }
    }

    trackAction(action: BookingAction | `venue_storefront_${string}`, attributes?: Record<string, any>) {
        if (!this.browserAgent) {
            if (action.startsWith('venue_storefront_') && environment.newRelicApplicationId.length > 0) {
                this.pendingStorefrontActions.push([action, { ...attributes }])
                if (this.pendingStorefrontActions.length > 100) {
                    this.pendingStorefrontActions.shift()
                }
            }
            return
        }
        try {
            this.browserAgent.addPageAction(action, attributes)
        } catch {
            // Observability must not interrupt a customer's booking.
        }
    }

    protected createBrowserAgent(options: ConstructorParameters<typeof BrowserAgent>[0]): BrowserAgent {
        return new BrowserAgent(options)
    }

    private makeOptions() {
        return {
            init: {
                distributed_tracing: {
                    enabled: true,
                    cors_use_newrelic_header: false,
                    cors_use_tracecontext_headers: true,
                    allowed_origins: [environment.apiBaseUrl],
                },
                privacy: { cookies_enabled: true },
                // Use explicit PageActions instead of automatically collecting DOM interactions.
                user_actions: { enabled: false },
                ajax: { deny_list: ['bam.eu01.nr-data.net'] },
            },
            info: {
                beacon: 'bam.eu01.nr-data.net',
                errorBeacon: 'bam.eu01.nr-data.net',
                licenseKey: 'NRJS-42809ed77caeb693bfa',
                applicationID: '',
                sa: 1,
            },
            loader_config: {
                accountID: '4432793',
                trustKey: '4432793',
                agentID: '',
                licenseKey: 'NRJS-42809ed77caeb693bfa',
                applicationID: '',
            },
            features: [
                GenericEvents,
            ]
        }
    }
}
